import Typography from '@mui/material/Typography';

const CustomHelperText = props => (
  <Typography
    variant='body2'
    style={{
      paddingTop: '0.25em',
      paddingRight: '0.25em',
      paddingLeft: '0.25em'
    }}
    color='grey'
  >
    {props.children}
  </Typography>
);

export default CustomHelperText;
